import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { CANCEL_KEYS, SHEETS_CONTAINER_TYPES } from '../utils/consts';
/**
 * `Service` The discipline service
 */
var Disciplines = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function Disciplines(sdk) {
    _classCallCheck(this, Disciplines);
    return _callSuper(this, Disciplines, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(Disciplines, _Base);
  return _createClass(Disciplines, [{
    key: "getDisciplines",
    value: (
    /**
     * Get disciplines
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/0ce490ffcc4e6-get-sheet-disciplines
     *
     * @param projectId - the project id
     * @param params - query parameters with shape of \{ sheetContainerType, includeCount, locale \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with sheet disciplines, shape of
     *                    [
     *                      \{
     *                        designator: string,
     *                        discipline: string,
     *                        count: number
     *                      \}
     *                    ]
     */
    function () {
      var _getDisciplines = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, params, config) {
        var _this = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this.loadDisciplinesCancelToken;
                },
                setter: function setter(token) {
                  return _this.loadDisciplinesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.loadDisciplinesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-disciplines").concat(query);
              _context.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context.sent;
              return _context.abrupt("return", response.data || []);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getDisciplines(_x, _x2, _x3) {
        return _getDisciplines.apply(this, arguments);
      }
      return getDisciplines;
    }()
    /**
     * Update disciplines list
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/95247d416a4fd-put-sheet-disciplines
     *
     * @param projectId - the project id
     * @param payload -, include the full list of disciplines, shape of
     *                    \{
     *                      disciplines: [
     *                        \{
     *                          designator: string, unique, max length: 10, only accept upper case
     *                          discipline: string
     *                        \}
     *                      ]
     *                    \}
     * @param params - query parameters with shape of \{ sheetContainerType \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with object \{ jobId \}
     */
    )
  }, {
    key: "updateDisciplines",
    value: (function () {
      var _updateDisciplines = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, payload, params, config) {
        var _this2 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.updateDisciplinesCancelToken;
                },
                setter: function setter(token) {
                  return _this2.updateDisciplinesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.updateDisciplinesCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-disciplines").concat(query);
              _context2.next = 5;
              return this.HttpService.dmV3.put(url, payload, conf);
            case 5:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || []);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateDisciplines(_x4, _x5, _x6, _x7) {
        return _updateDisciplines.apply(this, arguments);
      }
      return updateDisciplines;
    }()
    /**
     * Get job status of update disciplines list
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/56553d4f57dd5-get-the-status-of-the-given-discipline-creation
     *
     * @param projectId - the project id
     * @param jobId - the job id
     * @param params - query parameters with shape of \{ sheetContainerType \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with job status, shape of
     *                     \{
     *                       status: string, included in ['completed', 'failed', 'committed']
     *                     \}
     */
    )
  }, {
    key: "getJobStatus",
    value: (function () {
      var _getJobStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, jobId, params, config) {
        var _this3 = this;
        var conf, query, url, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.getJobStatusCancelToken;
                },
                setter: function setter(token) {
                  return _this3.getJobStatusCancelToken = token;
                },
                clearer: function clearer() {
                  return _this3.getJobStatusCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-disciplines/jobs/").concat(jobId).concat(query);
              _context3.next = 5;
              return this.HttpService.dmV3.get(url, conf);
            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getJobStatus(_x8, _x9, _x10, _x11) {
        return _getJobStatus.apply(this, arguments);
      }
      return getJobStatus;
    }()
    /**
     * Preview sheets count for a specific discipline
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/9935a1ab2d3ce-count-the-sheets-by-discipline-name
     *
     * @param projectId - the project id
     * @param payload -, include the designator of discipline, shape of
     *                      \{
     *                        designator: string, unique, max length: 10
     *                      \}
     * @param params - query parameters with shape of \{ sheetContainerType \}
     * @param config - Configurable object to overwrite request parameters.
     * @returns a promise with associated sheets count, \{ count: number \}
     */
    )
  }, {
    key: "previewSheetsCount",
    value: (function () {
      var _previewSheetsCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(projectId, payload) {
        var _this4 = this;
        var params,
          config,
          conf,
          query,
          url,
          response,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
              config = _args4.length > 3 ? _args4[3] : undefined;
              conf = _extends(_defineProperty({}, CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.previewSheetsCountCancelToken;
                },
                setter: function setter(token) {
                  return _this4.previewSheetsCountCancelToken = token;
                },
                clearer: function clearer() {
                  return _this4.previewSheetsCountCancelToken = undefined;
                }
              }), config);
              query = QS.stringify(_extends({
                sheetContainerType: SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/sheet-disciplines:countPreview").concat(query);
              _context4.next = 7;
              return this.HttpService.dmV3.post(url, payload, conf);
            case 7:
              response = _context4.sent;
              return _context4.abrupt("return", response.data);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function previewSheetsCount(_x12, _x13) {
        return _previewSheetsCount.apply(this, arguments);
      }
      return previewSheetsCount;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Disciplines';
    }
  }]);
}(Base);
export default Disciplines;